import { gql } from '@apollo/client';

export const SAVE_AUTHORIZATIONS_X_USER_GROUPS = gql`
  mutation saveAuthorizationsXUserGroups($input: [AuthorizationsXUserGroupsInput]) {
    saveAuthorizationsXUserGroups(input: $input) {
      commandId
    }
  }
`;

export const SAVE_AUTHORIZATION_X_DOCUMENT_TYPE_X_USER_GROUPS = gql`
  mutation saveAuthorizationXDocumentTypeXUserGroups($input: [AuthorizationXDocumentTypeXUserGroupsInput]) {
    saveAuthorizationXDocumentTypeXUserGroups(input: $input) {
      commandId
    }
  }
`;

export const UNREFINE_AUTHORIZATION = gql`
  mutation unrefineAuthorization($input: UnrefineAuthorizationInput) {
    unrefineAuthorization(input: $input) {
      commandId
    }
  }
`;

export const EXPORT_SECURITY_LIST = gql`
  mutation exportSecurityList($fileType: String) {
    exportSecurityList(fileType: $fileType) {
      fileId
      fileName
      filePath
      fileBytes
    }
  }
`;

export const EXPORT_USER_RIGHTS_DETAILS_LIST = gql`
  mutation exportUserRightsDetailsList($fileType: String) {
    exportUserRightsDetailsList(fileType: $fileType) {
      fileId
      fileName
      filePath
      fileBytes
    }
  }
`;

export const IMPORT_SECURITY_LIST = gql`
  mutation importSecurityList($input: Upload!) {
    importSecurityList(input: $input) {
      commandId
    }
  }
`;
